import { createContext } from "react"

export const initialState = {
    filter: null,
}

const initialDispatch = {}

export const HorizontalSigningStateContext = createContext(initialState)
export const HorizontalSigningDispatchContext = createContext(initialDispatch)
